import apiClient from './api'

function unwrap(response, fallback) {
  return response?.data?.data ?? response?.data ?? fallback
}

function normalizeSummary(summary = {}) {
  return {
    totalReceipts: Number(summary.totalReceipts || 0),
    normalizedReceipts: Number(summary.normalizedReceipts || 0),
    extractedReceipts: Number(summary.extractedReceipts || 0),
    ambiguousReceipts: Number(summary.ambiguousReceipts || 0),
    missingCurrencyReceipts: Number(summary.missingCurrencyReceipts || 0),
    assumedCurrencyReceipts: Number(summary.assumedCurrencyReceipts || 0),
    invalidCurrencyReceipts: Number(summary.invalidCurrencyReceipts || 0),
    nonIsoCurrencyReceipts: Number(summary.nonIsoCurrencyReceipts || 0),
    dashboardExcludedReceipts: Number(summary.dashboardExcludedReceipts || 0),
  }
}

function normalizeDiagnostics(response) {
  const data = unwrap(response, {})
  return {
    summary: normalizeSummary(data.summary),
    topRawTokens: Array.isArray(data.topRawTokens) ? data.topRawTokens : [],
    topMoneyExtractionSources: Array.isArray(data.topMoneyExtractionSources)
      ? data.topMoneyExtractionSources
      : [],
  }
}

function normalizeReceiptRows(response) {
  const data = unwrap(response, [])
  return (Array.isArray(data) ? data : []).map((row) => ({
    receiptId: String(row.receiptId || ''),
    createdAt: row.createdAt || null,
    source: row.source || '',
    status: row.status || '',
    host: row.host || null,
    totalOriginalAmountDecimal: row.totalOriginalAmountDecimal || null,
    totalOriginalCurrency: row.totalOriginalCurrency || null,
    totalOriginalAmountText: row.totalOriginalAmountText || null,
    moneyExtractionStatus: row.moneyExtractionStatus || null,
    moneyExtractionSource: row.moneyExtractionSource || null,
    dashboardIncluded: Boolean(row.dashboardIncluded),
    exclusionReason: row.exclusionReason || null,
  }))
}

function normalizeBackfillSummary(response) {
  const data = unwrap(response, {})
  return {
    scannedReceipts: Number(data.scannedReceipts || 0),
    scannedProducts: Number(data.scannedProducts || 0),
    updatedReceipts: Number(data.updatedReceipts || 0),
    updatedProducts: Number(data.updatedProducts || 0),
    normalizedAliases: Number(data.normalizedAliases || 0),
    assumedCurrencies: Number(data.assumedCurrencies || 0),
    ambiguousCurrencies: Number(data.ambiguousCurrencies || 0),
    missingCurrencies: Number(data.missingCurrencies || 0),
    invalidCurrencies: Number(data.invalidCurrencies || 0),
    unchanged: Number(data.unchanged || 0),
    errors: Number(data.errors || 0),
    samples: Array.isArray(data.samples) ? data.samples : [],
  }
}

export async function getCurrencyNormalizationDiagnostics() {
  return normalizeDiagnostics(
    await apiClient.get('/admin/currency-normalization/diagnostics'),
  )
}

export async function listCurrencyNormalizationReceipts(params = {}) {
  return normalizeReceiptRows(
    await apiClient.get('/admin/currency-normalization/receipts', { params }),
  )
}

export async function dryRunCurrencyNormalizationBackfill(options = {}) {
  return normalizeBackfillSummary(
    await apiClient.post('/admin/currency-normalization/backfill/dry-run', options),
  )
}

export async function applyCurrencyNormalizationBackfill(options = {}) {
  return normalizeBackfillSummary(
    await apiClient.post('/admin/currency-normalization/backfill/apply', {
      ...options,
      confirm: true,
    }),
  )
}

export default {
  getCurrencyNormalizationDiagnostics,
  listCurrencyNormalizationReceipts,
  dryRunCurrencyNormalizationBackfill,
  applyCurrencyNormalizationBackfill,
}
